// Little Catio cart drawer (port of the Glow Trail drawer). Shopify Ajax Cart API.
// Exposes window.CatioCart.open() / .close() / .refresh() / .add(variantId, qty).
(function () {
  const root = document.getElementById('CatioCart');
  if (!root) return;
  const D = JSON.parse(document.getElementById('CatioCartData').textContent);
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = id => document.getElementById(id);
  const money = c => (D.moneyFormat || '£{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2)).replace(/<[^>]*>/g, '');
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const products = {};
  let giftId = D.giftId || null;
  const isProtect = i => !!D.protectId && i.variant_id === D.protectId;
  const isGift = i => !!(i.properties && i.properties._catio_gift) || (!!giftId && i.variant_id === giftId) || i.handle === D.giftHandle;
  const isCatio = i => i.handle === D.productHandle && !isGift(i); // any Little Catio variant qualifies for the catnip
  const SV = D.setVariants || [];
  const lcs = t => String(t || '').toLowerCase();
  const svOf = id => SV.find(v => v.id === id) || null;
  const isPod = i => !isGift(i) && (svOf(i.variant_id) || {}).kind === 'pod';
  const isTwin = i => !isGift(i) && (svOf(i.variant_id) || {}).kind === 'twin';
  // the Twin Set in the same colour (or the only Twin Set while there are no colours)
  const twinFor = col => SV.find(v => v.kind === 'twin' && lcs(v.colour) === lcs(col)) || (col ? null : SV.find(v => v.kind === 'twin')) || null;
  const lineColour = i => { const o = (i.options_with_values || []).find(x => /^colou?r$/i.test(x.name)); return o ? o.value : (svOf(i.variant_id) || {}).colour || null; };
  const shopImg = (src, w) => src && /cdn\.shopify\.com|\/cdn\/shop\/files\//.test(src) && !/\/t\/\d+\/assets\//.test(src)
    ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : src;

  async function api(path, body) {
    const r = await fetch(R + path, body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  }
  async function product(handle) {
    if (!(handle in products)) {
      try { const r = await fetch(`${R}products/${handle}.js`); products[handle] = r.ok ? await r.json() : null; }
      catch (e) { products[handle] = null; }
    }
    return products[handle];
  }
  async function giftVariant() {
    if (giftId || !D.giftHandle) return giftId;
    const p = await product(D.giftHandle);
    const v = p && p.variants && (p.variants.find(x => x.available) || p.variants[0]);
    giftId = v ? v.id : null;
    return giftId;
  }

  /* ---------- free catnip: exactly one gift line while a Little Catio is in the cart, none otherwise ----------
     One pass per render, so no loops. If adding the gift fails (e.g. sold out) it isn't retried until the cart changes shape. */
  const blocked = new Set();
  async function syncGifts(cart) {
    try { await giftVariant(); } catch (e) {}
    const want = cart.items.some(isCatio) ? 1 : 0;
    const updates = {};
    let have = 0;
    cart.items.filter(isGift).forEach(l => {
      const keep = Math.max(0, Math.min(l.quantity, want - have));
      have += keep;
      if (keep !== l.quantity) updates[l.key] = keep;
    });
    let changed = false;
    if (Object.keys(updates).length) { cart = await api('cart/update.js', { updates }); changed = true; }
    const key = 'gift@' + cart.items.filter(isCatio).map(i => i.variant_id).join(',');
    if (giftId && have < want && !blocked.has(key)) {
      try { await api('cart/add.js', { items: [{ id: giftId, quantity: want - have, properties: { _catio_gift: '1' } }] }); }
      catch (e) { blocked.add(key); }
      cart = await api('cart.js'); changed = true;
    }
    // shipping protection on its own (cart otherwise empty) goes too
    if (cart.items.length && cart.items.every(i => isProtect(i) || isGift(i)) && cart.items.some(isProtect)) {
      const off = {}; cart.items.forEach(i => { off[i.key] = 0; });
      cart = await api('cart/update.js', { updates: off }); changed = true;
    }
    return { cart, changed };
  }

  // Syncs run one after another. A cart handed in is only used when nothing else was queued before it
  // (otherwise it may be stale), so two overlapping syncs can never fight over the gift line.
  let chain = Promise.resolve(), queued = 0, lastCart = null;
  function fix(cart) {
    const fresh = queued === 0;
    queued++;
    const p = chain.then(async () => {
      try {
        return await syncGifts(fresh && cart ? cart : await api('cart.js'));
      } catch (e) {
        console.error(e);
        return { cart: await api('cart.js'), changed: false };
      } finally { queued--; }
    });
    chain = p.catch(() => {});
    return p;
  }

  function setCount(cart) {
    const n = cart.items.filter(i => !isGift(i) && !isProtect(i)).reduce((a, i) => a + i.quantity, 0);
    document.querySelectorAll('[data-catio-count]').forEach(el => { el.textContent = n; el.hidden = !n; });
    const label = document.querySelector('[data-catio-cart-open]');
    if (label) label.setAttribute('aria-label', `Cart, ${n} item${n === 1 ? '' : 's'}`);
    return n;
  }

  async function render(cart) {
    cart = cart || await api('cart.js');
    cart = (await fix(cart)).cart;
    lastCart = cart;
    const count = setCount(cart);
    $('CatioCartN').textContent = count ? `(${count})` : '';
    $('CatioCartN').hidden = !count;
    root.classList.toggle('is-empty', !count);
    $('CatioCartEmpty').hidden = count > 0;

    // free delivery bar (protection doesn't count towards it)
    const goods = cart.items.filter(i => !isProtect(i)).reduce((a, i) => a + i.final_line_price, 0);
    const T = Number(D.threshold) || 0, free = !!D.freeAll || (T > 0 && goods >= T);
    const ship = $('CatioCartShip');
    ship.hidden = !count || (!D.freeAll && !T);
    ship.innerHTML = D.freeAll
      ? `<p class="lcart__ship-t is-free is-line"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>${esc(D.freeLine || 'Free tracked UK delivery')}</p>`
      : free
      ? `<p class="lcart__ship-t is-free"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>Free UK delivery unlocked</p><div class="lcart__bar is-full"><i style="width:100%"></i></div>`
      : `<p class="lcart__ship-t">You're <b>${money(T - goods)}</b> away from free UK delivery</p><div class="lcart__bar" role="progressbar" aria-valuemin="0" aria-valuemax="${T}" aria-valuenow="${goods}" aria-label="Progress to free UK delivery"><i style="width:${Math.min(100, Math.round(goods / T * 100))}%"></i></div>`;

    // line items (protection is the toggle, gifts are grouped underneath)
    let saved = 0, savedTwin = 0, twinQty = 0;
    const rows = await Promise.all(cart.items.filter(i => !isProtect(i) && !isGift(i)).map(async i => {
      const p = await product(i.handle);
      const v = p && p.variants ? p.variants.find(x => x.id === i.variant_id) : null;
      const full = v && v.compare_at_price > v.price ? v.compare_at_price * i.quantity : i.original_line_price;
      const save = Math.max(0, full - i.final_line_price);
      saved += save;
      if (save > 0 && isTwin(i)) { savedTwin += save; twinQty += i.quantity; }
      const catio = i.handle === D.productHandle;
      const img = shopImg((v && v.featured_image && v.featured_image.src) || i.image, 200) || (catio ? D.podImg : '');
      const setName = catio && i.options_with_values && i.options_with_values[0] ? i.options_with_values[0].value : i.variant_title;
      const name = catio ? (setName || i.product_title) : i.product_title;
      const sub = catio ? [i.product_title, lineColour(i)].filter(Boolean).join(' · ') : (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '');
      const line = cart.items.indexOf(i) + 1;
      return `<li class="lcart__item">
        <div class="lcart__img">${img ? `<img src="${esc(img)}" alt="" width="72" height="72">` : ''}</div>
        <div class="lcart__info">
          <p class="lcart__name">${esc(name)}</p>
          ${sub ? `<p class="lcart__var">${esc(sub)}</p>` : ''}
          ${save > 0 ? `<p class="lcart__save">You save ${money(save)}${isTwin(i) ? ` vs ${2 * i.quantity} Pods` : ''}</p>` : ''}
          <div class="lcart__row">
            <div class="lcart__qty" role="group" aria-label="Quantity of ${esc(name)}">
              <button type="button" data-line="${line}" data-q="${i.quantity - 1}" aria-label="One fewer">−</button>
              <span aria-live="polite">${i.quantity}</span>
              <button type="button" data-line="${line}" data-q="${i.quantity + 1}" aria-label="One more">+</button>
            </div>
            <div class="lcart__price">${save > 0 ? `<s>${money(full)}</s>` : ''}<b>${money(i.final_line_price)}</b></div>
          </div>
        </div>
        <button type="button" class="lcart__rm" data-line="${line}" data-q="0" aria-label="Remove ${esc(name)}"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button>
      </li>`;
    }));
    $('CatioCartItems').innerHTML = rows.join('');

    const gifts = cart.items.filter(isGift);
    const gEl = $('CatioCartGifts');
    gEl.hidden = !gifts.length || !count;
    gEl.innerHTML = gifts.map(i => `<div class="lcart__gift">
        <span class="lcart__gift-img"><img src="${esc(D.giftImg || shopImg(i.image, 160) || '')}" alt="" width="44" height="44"></span>
        <span class="lcart__gift-txt"><span class="lcart__gift-tag">Free gift</span><b>${esc(D.giftName || i.product_title)}</b><span>${esc(D.giftLine || '')}</span></span>
        <em class="${i.final_line_price === 0 ? 'is-free' : ''}">${i.final_line_price === 0 ? 'Free' : money(i.final_line_price)}</em>
      </div>`).join('');

    // upgrade card: The Pod → Twin Set, worked out from the real variant prices
    renderUpgrade(cart, goods);

    // shipping protection: opt-in only, never pre-ticked
    const prot = cart.items.find(isProtect);
    $('CatioCartProtect').hidden = !D.protectId || !D.protectAvailable || !count;
    $('CatioCartProtectPrice').textContent = D.protectPrice ? '+' + money(D.protectPrice) : '';
    $('CatioCartProtectToggle').checked = !!prot;

    // delivery line, then the subtotal (Shopify's total after discounts)
    const dEl = $('CatioCartDelivery');
    dEl.hidden = !count;
    dEl.innerHTML = free
      ? '<span>Tracked UK delivery</span><b class="is-free">Free</b>'
      : `<span>Tracked UK delivery</span><span>${D.shipPrice ? money(D.shipPrice) : 'Calculated at checkout'}</span>`;
    $('CatioCartTotal').textContent = money(cart.total_price);
    $('CatioCartSaved').hidden = saved <= 0;
    $('CatioCartSaved').textContent = saved > 0 ? `· you save ${money(saved)}${savedTwin === saved ? ` vs ${2 * twinQty} Pods` : ''}` : '';
    const go = $('CatioCartGo');
    go.classList.toggle('is-off', !count);
    if (!count) go.setAttribute('aria-disabled', 'true'); else go.removeAttribute('aria-disabled');
    return cart;
  }

  function renderUpgrade(cart, goods) {
    const el = $('CatioCartUp');
    const hide = () => { el.hidden = true; el.innerHTML = ''; };
    const podLines = cart.items.filter(isPod);
    const podQty = podLines.reduce((a, i) => a + i.quantity, 0); // the Buy X get Y discount can split Pods into separate lines
    const twinIn = cart.items.some(isTwin);
    // Pods per colour. Two Pods only merge into a Twin Set when they're the same colour (a Twin Set is one colour).
    const byColour = {};
    podLines.forEach(i => { const k = lcs(lineColour(i)); (byColour[k] = byColour[k] || { qty: 0, line: i }).qty += i.quantity; });
    const pair = Object.values(byColour).find(g => g.qty >= 2);
    const pod = pair ? pair.line : podLines[0];
    if (!pod) return hide();
    const podColour = lineColour(pod);
    const twin = twinFor(podColour);
    const pv = products[D.productHandle] && products[D.productHandle].variants;
    const twinP = twin && pv && pv.find(v => v.id === twin.id);
    const podP = pv && pv.find(v => v.id === pod.variant_id);
    if (!twin || !twinP || !podP || !twinP.available) return hide();
    const two = 2 * podP.price - twinP.price; // what the Twin Set saves against two single Pods
    const T = Number(D.threshold) || 0;
    const img = `<span class="lcart__up-img"><img src="${esc(twin.img || D.podImg)}" alt="" width="56" height="56"><em aria-hidden="true">×2</em></span>`;
    const inColour = podColour ? ` in ${esc(podColour)}` : '';
    const swapData = `data-swap="1" data-twin="${twin.id}" data-pod="${pod.variant_id}"`;
    if (pair && two > 0) {
      el.hidden = false;
      el.innerHTML = `<div class="lcart__up-card">${img}<div class="lcart__up-txt">
          <p class="lcart__up-h">Two Pods? The ${esc(D.twinName)} costs ${money(two)} less</p>
          <p class="lcart__up-p">Same 2 pods and 2 carry bags, with one free catnip gift.</p></div></div>
        <button type="button" class="lcart__up-btn" ${swapData} data-keep="${pair.qty - 2}">Switch to the ${esc(D.twinName)}${inColour} · save ${money(two)}</button>`;
      return;
    }
    if (podQty !== 1 || twinIn) return hide(); // mixed-colour Pods: no merge offer
    const extra = twinP.price - podP.price;
    const perks = [];
    if (D.upPerk) perks.push(esc(D.upPerk));
    if (!D.freeAll && T && goods < T && goods - podLines.reduce((a, i) => a + i.final_line_price, 0) + twinP.price >= T) perks.push(`<b>Free UK delivery</b>${D.shipPrice ? ` (save ${money(D.shipPrice)})` : ''}`);
    if (two > 0) perks.push(`${money(two)} less than two single Pods`);
    el.hidden = false;
    el.innerHTML = `<div class="lcart__up-card">${img}<div class="lcart__up-txt">
        <p class="lcart__up-h">Got two cats? Make it the ${esc(D.twinName)}</p>
        <ul>${perks.map(p => `<li>${p}</li>`).join('')}</ul></div></div>
      <button type="button" class="lcart__up-btn" ${swapData} data-keep="0">Upgrade to the ${esc(D.twinName)}${inColour} · +${money(extra)}</button>`;
  }

  /* ---------- open / close ---------- */
  let lastFocus = null;
  async function run(fn) {
    root.classList.add('is-busy');
    $('CatioCartErr').hidden = true;
    try { await fn(); }
    catch (e) {
      console.error(e);
      let msg = 'Sorry, that didn’t work. Please try again.';
      try { const j = JSON.parse(e.message); if (j && j.description) msg = j.description; } catch (x) {}
      $('CatioCartErr').textContent = msg; $('CatioCartErr').hidden = false;
      try { await render(); } catch (x) {}
    } finally { root.classList.remove('is-busy'); }
  }
  function open() {
    if (root.hidden) lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    document.documentElement.classList.add('lcart-open');
    setTimeout(() => { const x = root.querySelector('.lcart__x'); if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('lcart-open');
    setTimeout(() => { root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openAndRender() { open(); return run(() => render()); }

  // Add from the product page: the gift goes in with it when the cart doesn't have one yet, then the drawer opens.
  async function add(variantId, qty) {
    let items = [{ id: Number(variantId), quantity: qty || 1 }];
    try { await giftVariant(); } catch (e) {}
    const hasGift = lastCart && lastCart.items.some(isGift);
    const hasCatio = lastCart && lastCart.items.some(isCatio);
    if (giftId && (D.giftAvailable || !D.giftId) && lastCart && !hasGift && !hasCatio) items.push({ id: giftId, quantity: 1, properties: { _catio_gift: '1' } });
    try { await api('cart/add.js', { items }); }
    catch (e) {
      if (items.length < 2) throw e;
      items = items.slice(0, 1);
      await api('cart/add.js', { items }); // the gift failed (e.g. sold out): add the pod on its own
    }
    open();
    await run(() => render());
  }

  root.addEventListener('click', e => {
    if (e.target.closest('[data-close]')) return close();
    const go = e.target.closest('#CatioCartGo');
    if (go) { if (go.classList.contains('is-off')) e.preventDefault(); return; }
    const q = e.target.closest('[data-line]');
    if (q) return run(async () => render(await api('cart/change.js', { line: Number(q.dataset.line), quantity: Number(q.dataset.q) })));
    const sw = e.target.closest('[data-swap]');
    if (sw) return run(async () => {
      // add the Twin Set first, so a failed add never leaves the cart without the pod. Line keys change when the cart
      // changes, so the Pod line is looked up again (by variant) in the fresh cart before it's reduced.
      const keep = Number(sw.dataset.keep) || 0;
      const podId = Number(sw.dataset.pod), twinId = Number(sw.dataset.twin);
      await api('cart/add.js', { items: [{ id: twinId, quantity: 1 }] });
      const fresh = await api('cart.js');
      const lines = fresh.items.filter(i => i.variant_id === podId && !isGift(i));
      let remove = lines.reduce((a, i) => a + i.quantity, 0) - keep;
      const updates = {};
      lines.forEach(l => { const take = Math.max(0, Math.min(l.quantity, remove)); if (take) { updates[l.key] = l.quantity - take; remove -= take; } });
      await render(Object.keys(updates).length ? await api('cart/update.js', { updates }) : fresh);
    });
  });
  $('CatioCartProtectToggle').addEventListener('change', e => run(async () => {
    const cart = await api('cart.js');
    const prot = cart.items.find(isProtect);
    if (e.target.checked && !prot) await api('cart/add.js', { items: [{ id: D.protectId, quantity: 1 }] });
    if (!e.target.checked && prot) await api('cart/change.js', { id: prot.key, quantity: 0 });
    await render();
  }));
  document.addEventListener('keydown', e => {
    if (root.hidden) return;
    if (e.key === 'Escape') return close();
    if (e.key === 'Tab') { // keep focus inside the open drawer
      const f = Array.from(root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // header cart icon (and any /cart link) opens the drawer instead of leaving the page
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-catio-cart-open], a[href$="/cart"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || root.contains(a)) return;
    e.preventDefault(); openAndRender();
  });

  // Keep the gift right on page load (and on Dawn's /cart page, which changes the cart without the drawer).
  const onCartPage = /\/cart\/?$/.test(location.pathname);
  async function quietSync() {
    try {
      const c = await api('cart.js');
      const res = await fix(c);
      lastCart = res.cart; setCount(res.cart);
      if (res.changed && onCartPage) location.reload();
    } catch (e) { console.error(e); }
  }
  if (D.itemCount > 0 || onCartPage) quietSync(); else lastCart = { items: [] };
  if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => { if (root.hidden) quietSync(); });

  window.CatioCart = { open: openAndRender, close, refresh: () => run(() => render()), add };
})();
